import { setLocale } from 'yup';

import { CustomPlugin } from '@/types';
import { i18n } from './i18n';

const { t } = i18n.global;

const plugin: CustomPlugin = {
  install: () => {
    setLocale({
      mixed: {
        required: t('validation.mixed.required'),
        notType: t('validation.mixed.notType'),
      },
      string: {
        email: t('validation.string.email'),
      },
      number: {
        positive: t('validation.number.positive'),
        max: ({ max }) => t('validation.number.max', { max }),
        min: ({ min }) => t('validation.number.min', { min }),
      },
    });
  },
};

export default plugin;
